import React from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { colors, typography } from '../../../styles/theme';
import {
  filterSectionLabelStyle,
  filterGroupDividerStyle,
  filterPanelGutterStyle,
  FILTER_ACCENT_27,
} from './FilterPanel.styles';

const headerBtnStyle = (open, isFirst) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '8px',
  // Primer grupo: mismo aire que BÁSICOS respecto a la línea de tabs.
  // Cerrado: mismo aire arriba y abajo para centrar el título entre divisores.
  // Abierto: menos padding abajo para acercar los controles al título.
  padding: open
    ? (isFirst ? '16px 0 8px' : '12px 0 8px')
    : (isFirst ? '16px 0' : '12px 0'),
  margin: 0,
  border: 'none',
  background: 'none',
  cursor: 'pointer',
  textAlign: 'left',
});

const badgeStyle = {
  marginLeft: '6px',
  padding: '1px 6px',
  borderRadius: '999px',
  backgroundColor: FILTER_ACCENT_27,
  color: colors.textPanelDescription,
  fontSize: typography.fontSize.xs,
  fontWeight: typography.fontWeight.medium,
};

const bodyStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  paddingBottom: '14px',
};

function FilterAccordion({
  groupId,
  label,
  activeCount = 0,
  defaultOpen = false,
  accordion = true,
  showDivider = false,
  children,
}) {
  const [open, setOpen] = React.useState(defaultOpen || !accordion);
  const dividerStyle = showDivider ? filterGroupDividerStyle : null;

  if (!accordion) {
    return (
      <div style={dividerStyle} data-filter-group={groupId}>
        <div style={filterPanelGutterStyle}>
          <div style={{
            ...filterSectionLabelStyle,
            marginTop: 0,
            marginBottom: '8px',
            paddingTop: showDivider ? '12px' : '16px',
          }}>
            {label}
          </div>
          <div style={bodyStyle}>{children}</div>
        </div>
      </div>
    );
  }

  const title = activeCount > 0 ? `${label} · ${activeCount}` : label;

  return (
    <div style={dividerStyle} data-filter-group={groupId}>
      <div style={filterPanelGutterStyle}>
        <button
          type="button"
          style={headerBtnStyle(open, !showDivider)}
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
        >
          <span style={{
            ...filterSectionLabelStyle,
            margin: 0,
            textTransform: 'uppercase',
            color: colors.textSecondary,
          }}
          >
            {title}
            {activeCount > 0 && !open && (
              <span style={badgeStyle}>{activeCount}</span>
            )}
          </span>
          {open
            ? <KeyboardArrowUpIcon sx={{ fontSize: 18, color: colors.textSecondary }} />
            : <KeyboardArrowDownIcon sx={{ fontSize: 18, color: colors.textSecondary }} />}
        </button>
        {open && <div style={bodyStyle}>{children}</div>}
      </div>
    </div>
  );
}

export default FilterAccordion;
